var standalone = window.navigator.standalone,
  userAgent = window.navigator.userAgent.toLowerCase(),
  safari = /safari/.test(userAgent),
  ios = /iphone|ipod|ipad/.test(userAgent);

function getAllUrlParams(url) {
  var queryString = url ? url.split("?")[1] : window.location.search.slice(1);
  var obj = {};

  if (queryString) {
    queryString = queryString.split("#")[0];

    var arr = queryString.split("&");

    for (var i = 0; i < arr.length; i++) {
      var a = arr[i].split("=");

      var paramNum = undefined;
      var paramName = a[0].replace(/\[\d*\]/, function(v) {
        paramNum = v.slice(1, -1);
        return "";
      });

      var paramValue = typeof a[1] === "undefined" ? true : a[1];

      paramName = paramName.toLowerCase();
      paramValue = paramValue.toLowerCase();

      if (obj[paramName]) {
        if (typeof obj[paramName] === "string") {
          obj[paramName] = [obj[paramName]];
        }

        if (typeof paramNum === "undefined") {
          obj[paramName].push(paramValue);
        } else {
          obj[paramName][paramNum] = paramValue;
        }
      } else {
        obj[paramName] = paramValue;
      }
    }
  }
  return obj;
}

window.onload = function() {
  var i = document.getElementById("back-button"),
    n = document.getElementById("page--container"),
    url = window.location.href;

  if (getAllUrlParams(url).direct === "true") {
    i.style.display = "none";
  } else if (typeof getAllUrlParams(url).direct === "undefined") {
    if (ios) {
      if (!standalone && safari) {
        // "browser";
        i.style.display = "none";
        if (n) {
          n.style.marginTop = "-15px";
        }
      } else if (standalone && !safari) {
        // "standalone";
        i.style.display = "none";
        if (n) {
          n.style.marginTop = "-15px";
        }
      } else if (!standalone && !safari) {
        // "uiwebview";
        i.style.display = "block";
      }
    } else {
      // "not iOS";
      i.style.display = "none";
      if (n) {
        n.style.marginTop = "-15px";
      }
    }
  }

  (function() {
    var accordions, i;
    if (!document.querySelectorAll || !document.body.classList) return;
    function makeAccordion(accordion) {
      var targets, currentTarget, i;
      targets = accordion.querySelectorAll(".accordionTabs > * > h1 ");
      for (i = 0; i < targets.length; i++) {
        targets[i].addEventListener(
          "click",
          function(e) {
            if (e.target.parentNode.classList.contains("expanded")) {
              e.target.parentNode.classList.remove("expanded");
            } else {
              if (currentTarget) currentTarget.classList.remove("expanded");

              currentTarget = this.parentNode;
              currentTarget.classList.add("expanded");
              currentTarget.scrollIntoView(true);
            }
          },
          false
        );
      }
      accordion.classList.add("js");
    }
    accordions = document.querySelectorAll(".accordionTabs");
    for (i = 0; i < accordions.length; i++) {
      makeAccordion(accordions[i]);
    }
  })();
};
